// extracted by mini-css-extract-plugin
export default {"container":"Spinner_container__Jm2fX","innerContainer":"Spinner_innerContainer__blIKx","rotate":"Spinner_rotate__+-jSa"};